"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _I18n = _interopRequireDefault(require("I18n"));

var _range = _interopRequireDefault(require("../utils/underscore/range"));

var _pick = _interopRequireDefault(require("../utils/underscore/pick"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _UIIconToggle = _interopRequireDefault(require("./UIIconToggle"));

var _Functions = require("../core/Functions");

var _ComponentWithPartials = _interopRequireDefault(require("../mixins/ComponentWithPartials"));

var _Controllable = _interopRequireDefault(require("../decorators/Controllable"));

var _SyntheticEvent = _interopRequireDefault(require("../core/SyntheticEvent"));

var _TabIndex = require("../utils/TabIndex");

var composedPropTypes = ['checkedColor', 'checkedIcon', 'iconSize', 'uncheckedColor', 'uncheckedIcon'];

var UIIconRating = _react.default.createClass({
  displayName: "UIIconRating",
  mixins: [_ComponentWithPartials.default],
  propTypes: (0, _extends2.default)({}, (0, _pick.default)(_UIIconToggle.default.propTypes, composedPropTypes), {
    disabled: _propTypes.default.bool,
    iconClassName: _propTypes.default.string,
    iconCount: _propTypes.default.number,
    onChange: _propTypes.default.func,
    value: _propTypes.default.number,
    showPercentage: _propTypes.default.bool.isRequired
  }),
  getDefaultProps: function getDefaultProps() {
    return (0, _extends2.default)({}, (0, _pick.default)(_UIIconToggle.default.defaultProps, composedPropTypes), {
      iconCount: 5,
      showPercentage: false
    });
  },
  getInitialState: function getInitialState() {
    return {
      focusValue: null
    };
  },
  getPercentageFilled: function getPercentageFilled(index, value) {
    if (value == null) {
      return 0;
    }

    if (this.state.focusValue) {
      if (index <= this.state.focusValue) {
        return 100;
      }

      return 0;
    }

    if (index <= Math.floor(value)) {
      return 100;
    }

    if (index > Math.ceil(value)) {
      return 0;
    }

    return Math.round(value % 1 * 100);
  },
  getIsHighlighted: function getIsHighlighted(index, value) {
    if (this.state.focusValue) {
      return index <= this.state.focusValue;
    }

    return index <= Math.ceil(value);
  },
  handleChange: function handleChange(value) {
    if (this.props.disabled) {
      return;
    }

    (0, _Functions.callIfPossible)(this.props.onChange, (0, _SyntheticEvent.default)(value));
  },
  handleKeyDown: function handleKeyDown(evt) {
    var _this$props = this.props,
        iconCount = _this$props.iconCount,
        value = _this$props.value;
    var nextValue = value || 0;

    if (evt.key === 'ArrowLeft') {
      nextValue = Math.floor(nextValue) <= 0 ? 0 : Math.ceil(nextValue) - 1;
    } else if (evt.key === 'ArrowRight') {
      nextValue = Math.ceil(nextValue) >= iconCount ? iconCount : Math.floor(nextValue) + 1;
    }

    this.handleChange(nextValue);
  },
  handleHover: function handleHover(value) {
    if (this.props.disabled) {
      return;
    }

    this.setState({
      focusValue: value
    });
  },
  render: function render() {
    var _this = this;

    var _this$props2 = this.props,
        className = _this$props2.className,
        disabled = _this$props2.disabled,
        iconClassName = _this$props2.iconClassName,
        iconCount = _this$props2.iconCount,
        __onChange = _this$props2.onChange,
        showPercentage = _this$props2.showPercentage,
        tabIndex = _this$props2.tabIndex,
        value = _this$props2.value,
        rest = (0, _objectWithoutProperties2.default)(_this$props2, ["className", "disabled", "iconClassName", "iconCount", "onChange", "showPercentage", "tabIndex", "value"]);
    var computedClassName = (0, _classnames.default)(className, 'private-form__icon-rating', {
      'private-form__icon-rating--disabled': disabled
    });
    return _react.default.createElement("div", {
      "aria-disabled": disabled,
      "aria-valuemax": iconCount,
      "aria-valuemin": "0",
      "aria-valuenow": value || 0,
      "aria-valuetext": _I18n.default.text('salesUI.UIIconRating.ariaValueText', {
        value: value || 0,
        maxValue: iconCount
      }),
      className: computedClassName,
      role: "slider",
      tabIndex: (0, _TabIndex.getTabIndex)(disabled, tabIndex),
      onKeyDown: this.handleKeyDown
    }, (0, _range.default)(1, iconCount + 1).map(function (i) {
      return _react.default.createElement(_UIIconToggle.default, (0, _extends2.default)({}, rest, {
        "aria-label": "",
        checked: _this.getIsHighlighted(i, value),
        className: iconClassName,
        disabled: disabled,
        key: i,
        onChange: _this.partial(_this.handleChange, i),
        onMouseEnter: _this.partial(_this.handleHover, i),
        onMouseLeave: _this.partial(_this.handleHover, null),
        percentFilled: showPercentage ? _this.getPercentageFilled(i, value) : null,
        _tabbable: false
      }));
    }));
  }
});

var _default = (0, _Controllable.default)(UIIconRating);

exports.default = _default;
module.exports = exports.default;